<p-dialog
    [visible]="visible"
    (visibleChange)="this.close()"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    appendTo="body"
    styleClass="skill-create-dialog"
    [style]="{'width': '680px', 'max-width': '95vw'}"
>
    <ng-template #header>
        @if (!selectedType) {
        <span
            class="fw-bold"
            i18n="@@add-skill"
        >Skill hinzufügen</span>
        } @else {
        <div class="d-flex align-items-center gap-2">
            <p-button
                icon="ri ri-arrow-left-line"
                [text]="true"
                [plain]="true"
                size="small"
                (onClick)="this.back()"
            />
            <span class="fw-bold">
                <i [ngClass]="'ri-xl me-2 ' + selectedType.icon"></i>
                {{ selectedType.name }}
            </span>
        </div>
        }
    </ng-template>

    <!-- Step 1: Typ-Auswahl -->
    @if (!selectedType) {
    <p
        class="text-muted mb-3"
        i18n="@@select-skill-type"
    >Skills stellen dem KI-Modell gezielt Wissen bereit – genau dann, wenn es gebraucht wird. Wähle aus, welche
        Wissensquelle oder Funktion du hinzufügen möchtest.</p>
    <div class="skill-type-grid">
        @for (type of skillTypes; track type.toolId) {
        <div
            class="skill-type-card"
            (click)="this.selectType(type)"
        >
            <i [ngClass]="'ri-2x mb-2 ' + type.icon + ' text-primary'"></i>
            <span class="skill-type-name fw-semibold">{{ type.name }}</span>
            <span class="skill-type-desc text-muted small">{{ type.description }}</span>
        </div>
        }
    </div>
    }

    @if (selectedType && selectedType.formType === 'form-file') {
    <div class="d-flex flex-column gap-3">
        <div>
            <label for="skill-document-description" class="form-label fw-semibold">
                <span i18n="@@skill-trigger-label">Wann soll der Bot diesen Skill nutzen?</span>
                <span class="skill-required" i18n="@@skill-required">(Pflichtfeld)</span>
            </label>
            <textarea
                #descriptionInput
                id="skill-document-description"
                pTextarea
                class="w-100"
                [(ngModel)]="formDescription"
                (blur)="descriptionTouched = true"
                [invalid]="descriptionInvalid"
                [attr.aria-invalid]="descriptionInvalid"
                [attr.aria-describedby]="descriptionInvalid ? 'skill-document-description-error' : null"
                [readonly]="isCreating"
                required
                rows="3"
                i18n-placeholder="@@description-placeholder"
                placeholder="Beschreibe typische Fragen oder Situationen, in denen der Bot diesen Skill einsetzen soll."
            ></textarea>
            @if (descriptionInvalid) {
            <p id="skill-document-description-error" class="skill-field-error" role="alert"
                i18n="@@skill-document-description-required">Bitte beschreibe, wann der Bot diesen Skill nutzen soll.</p>
            }
        </div>
        <p-tabs [(value)]="formFileMode" [lazy]="false">
            <p-tablist>
                <p-tab value="project" [disabled]="isCreating" i18n="@@skill-document-project-tab">Aus Projekt</p-tab>
                <p-tab value="upload" [disabled]="isCreating" i18n="@@skill-document-upload-tab">Neue Datei</p-tab>
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel value="project">
                    <div #documentProjectSource tabindex="-1"
                        [attr.aria-describedby]="documentSourceInvalid && formFileMode === 'project' ? 'skill-document-project-error' : null">
                        <label id="skill-document-project-label" for="skill-document-project" class="form-label fw-semibold">
                            <span i18n="@@skill-document-project-label">Projektdokument</span>
                            <span class="skill-required" i18n="@@skill-required">(Pflichtfeld)</span>
                        </label>
                        @if (selectableDocsLoading) {
                        <p class="text-muted small" i18n="@@project-docs-loading">Laden…</p>
                        } @else if (selectableDocuments.length === 0) {
                        <p class="text-muted small" i18n="@@skill-document-project-empty">Noch keine Projektdokumente vorhanden. Wähle im Tab „Neue Datei“ eine Datei aus.</p>
                        } @else {
                        <p-select
                            #documentProjectSelect
                            inputId="skill-document-project"
                            [options]="selectableDocuments"
                            [(ngModel)]="formSelectedProjectDoc"
                            [invalid]="documentSourceInvalid && formFileMode === 'project'"
                            [disabled]="isCreating"
                            [ariaLabelledBy]="documentSourceInvalid && formFileMode === 'project' ? 'skill-document-project-label skill-document-project-error' : 'skill-document-project-label'"
                            optionLabel="filename"
                            i18n-placeholder="@@select-document-placeholder"
                            placeholder="Dokument auswählen"
                            [filter]="true"
                            filterBy="filename"
                            [virtualScroll]="true"
                            [virtualScrollItemSize]="38"
                            class="w-100"
                            appendTo="body"
                        />
                        }
                        @if (documentSourceInvalid && formFileMode === 'project' && !selectableDocsLoading) {
                        <p id="skill-document-project-error" class="skill-field-error" role="alert"
                            i18n="@@skill-document-project-required">Bitte wähle ein Dokument aus dem Projekt oder wechsle zum Tab „Neue Datei“.</p>
                        }
                    </div>
                </p-tabpanel>
                <p-tabpanel value="upload">
                    <label for="skill-document-upload" class="form-label fw-semibold">
                        <span i18n="@@skill-document-file-label">Datei auswählen</span>
                        <span class="skill-required" i18n="@@skill-required">(Pflichtfeld)</span>
                    </label>
                    <input
                        #documentUploadInput
                        id="skill-document-upload"
                        type="file"
                        class="form-control"
                        [class.is-invalid]="documentSourceInvalid && formFileMode === 'upload'"
                        [attr.aria-invalid]="documentSourceInvalid && formFileMode === 'upload'"
                        [attr.aria-describedby]="documentSourceInvalid && formFileMode === 'upload' ? 'skill-document-upload-hint skill-document-upload-error' : 'skill-document-upload-hint'"
                        [disabled]="isCreating"
                        required
                        (change)="onFileSelected($event)"
                    />
                    <p id="skill-document-upload-hint" class="text-muted small mt-2 mb-0"
                        i18n="@@skill-document-upload-hint">Die Datei wird beim Erstellen hochgeladen.</p>
                    @if (documentSourceInvalid && formFileMode === 'upload') {
                    <p id="skill-document-upload-error" class="skill-field-error" role="alert"
                        i18n="@@skill-document-file-required">Bitte wähle eine Datei aus.</p>
                    }
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </div>
    }

    <!-- Webhooks: Name und URL -->
    @if (selectedType && selectedType.formType === 'name-url') {
    <div class="d-flex flex-column gap-3">
        <div>
            <label for="skill-name" class="form-label fw-semibold">
                <span i18n="@@name">Name</span>
                <span class="skill-required" i18n="@@skill-required">(Pflichtfeld)</span>
            </label>
            <input
                #nameInput
                id="skill-name"
                pInputText
                class="w-100"
                [(ngModel)]="formName"
                (blur)="nameTouched = true"
                [invalid]="nameInvalid"
                [attr.aria-invalid]="nameInvalid"
                [attr.aria-describedby]="nameInvalid ? 'skill-name-error' : null"
                [readonly]="isCreating"
                required
                i18n-placeholder="@@name-placeholder"
                placeholder="Name des Skills"
            />
            @if (nameInvalid) {
            <p id="skill-name-error" class="skill-field-error" role="alert"
                i18n="@@skill-name-required">Bitte gib einen Namen für den Skill ein.</p>
            }
        </div>
        <ng-container [ngTemplateOutlet]="urlField" />
    </div>
    }

    <!-- Weitere Skills: Beschreibung und gegebenenfalls URL -->
    @if (selectedType && (selectedType.formType === 'form' || selectedType.formType === 'form-url')) {
    <div class="d-flex flex-column gap-3">
        <div>
            <label for="skill-description" class="form-label fw-semibold">
                <span i18n="@@skill-trigger-label">Wann soll der Bot diesen Skill nutzen?</span>
                <span class="skill-required" i18n="@@skill-required">(Pflichtfeld)</span>
            </label>
            <textarea
                #descriptionInput
                id="skill-description"
                pTextarea
                class="w-100"
                [(ngModel)]="formDescription"
                (blur)="descriptionTouched = true"
                [invalid]="descriptionInvalid"
                [attr.aria-invalid]="descriptionInvalid"
                [attr.aria-describedby]="descriptionInvalid ? 'skill-description-error' : null"
                [readonly]="isCreating"
                required
                rows="3"
                i18n-placeholder="@@description-placeholder"
                placeholder="Beschreibe typische Fragen oder Situationen, in denen der Bot diesen Skill einsetzen soll."
            ></textarea>
            @if (descriptionInvalid) {
            <p id="skill-description-error" class="skill-field-error" role="alert"
                i18n="@@skill-document-description-required">Bitte beschreibe, wann der Bot diesen Skill nutzen soll.</p>
            }
        </div>
        @if (selectedType.formType === 'form-url') {
        <ng-container [ngTemplateOutlet]="urlField" />
        }
        @if (selectedType.toolId === 'websitescrape') {
        <div>
            <label id="skill-depth-label" for="skill-depth" class="form-label fw-semibold">
                <span i18n="@@page-depth-hint">Gib hier die Seitentiefe ein, wie tief die Verlinkungen verfolgt werden sollen.</span>
                <span class="skill-required" i18n="@@skill-required">(Pflichtfeld)</span>
            </label>
            <p-inputnumber
                #depthInput
                inputId="skill-depth"
                class="w-100"
                [min]="0"
                [max]="1"
                [(ngModel)]="formDepth"
                (onBlur)="depthTouched = true"
                [invalid]="depthInvalid"
                [disabled]="isCreating"
                [ariaLabelledBy]="depthInvalid ? 'skill-depth-label skill-depth-error' : 'skill-depth-label'"
                mode="decimal"
                fluid
            />
            @if (depthInvalid) {
            <p id="skill-depth-error" class="skill-field-error" role="alert"
                i18n="@@skill-depth-invalid">Bitte gib eine Seitentiefe von 0 oder 1 ein.</p>
            }
        </div>
        }
    </div>
    }

    <ng-template #urlField>
        <div>
            <label for="skill-url" class="form-label fw-semibold">
                URL
                <span class="skill-required" i18n="@@skill-required">(Pflichtfeld)</span>
            </label>
            <input
                #urlInput
                id="skill-url"
                pInputText
                class="w-100"
                [(ngModel)]="formUrl"
                (blur)="urlTouched = true"
                [invalid]="urlInvalid"
                [attr.aria-invalid]="urlInvalid"
                [attr.aria-describedby]="urlInvalid ? 'skill-url-error' : null"
                [readonly]="isCreating"
                required
                type="url"
                placeholder="https://"
            />
            @if (urlInvalid) {
            <p id="skill-url-error" class="skill-field-error" role="alert"
                i18n="@@skill-url-invalid">Bitte gib eine vollständige URL mit https:// oder http:// ein.</p>
            }
        </div>
    </ng-template>

    <ng-template #footer>
        @if (selectedType && selectedType.formType !== 'navigate') {
        <p-button
            i18n-label="@@cancel"
            label="Abbrechen"
            [text]="true"
            [plain]="true"
            (onClick)="this.close()"
        />
        <p-button
            i18n-label="@@create"
            label="Erstellen"
            icon="ri ri-add-line"
            [disabled]="isCreating"
            [loading]="isCreating"
            (onClick)="this.create()"
        />
        }
    </ng-template>
</p-dialog>